let basePath = window.location.protocol + '//' + window.location.host + window.location.pathname

//let ROOT = `${basePath}api`
let ROOT = `${basePath}`
if (process.env.NODE_ENV == 'development') {
  ROOT = `${basePath}`
}


export { basePath, ROOT}



// WEBPACK FOOTER //
// ./src/assets/js/config.js